import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as participationStyles from "../../styles/world_championships/Participation.module.css"

const Participation = props => {
  const { content } = props

  const how = ChildSelector.select(
    content,
    `participation-how`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const intro = ChildSelector.select(
    content,
    `participation-intro`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  return (
    <section id="participate" className={participationStyles.participationSection}>
      <div className={participationStyles.content}>
        <h3 className={participationStyles.mainTitle}>
          {how || "How Do I Participate?"}
        </h3>
        <div className={participationStyles.infoCard}>
          {intro.slice(0, 1).map((item, index) => (
            <p
              key={index}
              className={participationStyles.infoText}
              dangerouslySetInnerHTML={{ __html: item.innerHTML }}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Participation
